import { render, staticRenderFns } from "./PhoneSimManageList.vue?vue&type=template&id=30a8d0c3&scoped=true"
import script from "./PhoneSimManageList.vue?vue&type=script&lang=js"
export * from "./PhoneSimManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a8d0c3",
  null
  
)

export default component.exports